<template>
    <div class="help-menus small sticky d-none d-lg-block">
        <div v-for="(h, i) in headers" :key="i" :class="h.tagName">
            <a :href="'#' + encodeURI(h.textContent)" @click.prevent="jumpTo(i, h.textContent)">
                {{h.textContent}}
            </a>
        </div>
    </div>
</template>

<style scoped>
.help-menus {
    padding: 1rem 0;
    border-top: 1px dashed #ddd;
}
.H4 { padding-left: 1rem; }
.H5 { padding-left: 2rem; }
.H6 { padding-left: 3rem; }
</style>

<script>
export default {
    data() {
        return {
            headers: [],
        }
    },
    methods: {
        initMenus() {
            this.headers = [];
            for(const header of $("#help-manual :header")) {
                this.headers.push(header);
            }
            if (this.$route.hash) {
                const textContent = decodeURI(this.$route.hash.replace(/^#/, ''));
                const i = _.findIndex(this.headers, {textContent: textContent});
                if (i) {
                    this.jumpTo(i, textContent);
                }
            }
        },
        jumpTo(i, textContent) {
            this.$router.push({
                path: this.$route.path + "#" + encodeURI(textContent),
            }).catch(err => {});
            const t = $("#help-manual :header")[i].offsetTop;
            $("html,body").animate({scrollTop: t}, 500);
        },
    },
    watch: {
        $route(n, o) {
            if (n.path.match(/\/help/)) {
                setTimeout(() => {
                    this.initMenus();
                }, 400);
            }
        }
    },
    mounted() {
        this.initMenus();
    }
}
</script>